<template>
  <div>
    <pop-daren-num ref="popDarenNumRef"></pop-daren-num>
    <pop-distribute-goods-num ref="popDistributeGoodsNumRef"></pop-distribute-goods-num>
    <pop-settled-commission ref="popSettledCommissionRef"></pop-settled-commission>
    <non-coupon-commission-detail ref="nonCouponCommissionDetailRef"></non-coupon-commission-detail>
    <non-coupon-commission-setting
      ref="nonCouponCommissionSettingRef"
      @success="handleNonCouponCommissionSuccess"
    ></non-coupon-commission-setting>
    <non-coupon-auto-settle-setting
      ref="nonCouponAutoSettleSettingRef"
      @success="handleNonCouponAutoSettleSuccess"
    ></non-coupon-auto-settle-setting>
    <non-coupon-manual-settlement
      ref="nonCouponManualSettlementRef"
      @success="handleNonCouponManualSettlementSuccess"
    ></non-coupon-manual-settlement>
    <external-fee-config-pop ref="externalFeeConfigRef"></external-fee-config-pop>
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item prop="searchContent">
          <el-input
              style="width:300px"
              :maxlength="50"
              v-model="searchForm.searchContent"
              placeholder="推广者名称"
          />
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-date-picker-->
<!--              v-model="searchForm.timeArr"-->
<!--              format="yyyy-MM-dd"-->
<!--              value-format="yyyy-MM-dd HH:mm:ss"-->
<!--              type="daterange"-->
<!--              range-separator="-"-->
<!--              start-placeholder="注册开始日期"-->
<!--              end-placeholder="注册结束日期"-->
<!--              :default-time="['00:00:00', '23:59:59']"-->
<!--          >-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <el-form-item class="toolbar-actions">
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button type="primary" @click="onExport" :disabled="exportLoading" :loading="exportLoading">导出</el-button>
          <el-button type="primary" @click="handleBatchNonCouponCommission">批量设置非券订单佣金</el-button>
          <el-button type="primary" @click="handleOpenNonCouponAutoSettleSetting">非券订单自动结佣设置</el-button>
          <el-button type="primary" @click="handleOpenNonCouponManualSettlement">非券订单佣金手动结佣</el-button>
          <el-button type="primary" @click="handleOpenExternalFeeConfig">自营团长结算设置</el-button>
<!--          <span class="selected-ids">已选ID：{{ selectedIds.length ? selectedIds.join(', ') : '无' }}</span>-->
        </el-form-item>
      </el-form>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="tableList.list"
        row-key="id"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        highlight-current-row
        border
        style="width: 100%">
      <el-table-column type="selection" width="55" :reserve-selection="true" />
      <el-table-column prop="id" label="ID" width="230"/>
      <el-table-column prop="nickname" width="230" label="推广者名称" />
      <el-table-column prop="mobile" label="注册手机号" width="180" />
      <el-table-column prop="darenNum" label="关联达人数" width="150">
        <template slot-scope="scope">
          <el-link v-if="scope.row.darenNum" type="text" @click="handleDarenNum(scope.row)">
            {{scope.row.darenNum }}
          </el-link>
          <div v-else>
            {{scope.row.darenNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="distributeGoodsNum" label="推广商品数">
        <template slot-scope="scope">
<!--          <el-link v-if="scope.row.distributeGoodsNum" type="text" @click="handleDistributeGoodsNum(scope.row)">-->
<!--            {{scope.row.distributeGoodsNum }}-->
<!--          </el-link>-->
<!--          <div v-else>-->
<!--            {{scope.row.distributeGoodsNum }}-->
<!--          </div>-->
          {{scope.row.distributeGoodsNum }}
        </template>
      </el-table-column>
      <el-table-column prop="settledCommissionBd" label="团长服务费">
        <template slot-scope="scope">
          <el-link v-if="scope.row.settledCommissionBd" type="text" @click="handleSettledCommission(scope.row)">
            {{scope.row.settledCommissionBd }}
          </el-link>
          <div @click="handleSettledCommission(scope.row)" v-else>
            {{scope.row.settledCommissionBd }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="nonCouponCommission" label="非券订单佣金(含本月预估)" width="220">
        <template slot-scope="scope">
          <el-link
            v-if="Number(scope.row.nonCouponCommission) > 0"
            type="text"
            @click="handleNonCouponCommissionDetail(scope.row)"
          >
            {{ scope.row.nonCouponCommission }}
          </el-link>
          <div v-else>{{ scope.row.nonCouponCommission == null ? 0 : scope.row.nonCouponCommission }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="registerTime" label="注册时间" width="180" />
      <el-table-column label="操作" width="170" align="left">
        <template slot-scope="{row}">
          <div class="operation-links">
            <el-link type="text" @click="handleManage(row)">
              <i class="el-icon-setting"></i> 券商品佣金设置
            </el-link>
            <el-link type="text" @click="handleNonCouponCommission(row)">
              <i class="el-icon-setting"></i> 非券订单佣金设置
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
    >
    </el-pagination>
    <group-commission-pop ref="groupCommissionPopRef" @refresh="handleRefresh"></group-commission-pop>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import manageDetailPop from './manageDetailPop.vue';
import GroupSettingPop from "./groupSettingPop.vue";
import ContactInfo from "./contactInfo.vue";
import poi from "@/api/poi";
import PopDarenNum from "./popDarenNum.vue";
import PopDistributeGoodsNum from "./popDistributeGoodsNum.vue";
import PopSettledCommission from "./popSettledCommission.vue";
import NonCouponCommissionDetail from "./commissioSetting/nonCouponCommissionDetail.vue";
import NonCouponCommissionSetting from "./commissioSetting/nonCouponCommissionSetting.vue";
import NonCouponAutoSettleSetting from "./commissioSetting/nonCouponAutoSettleSetting.vue";
import NonCouponManualSettlement from "./commissioSetting/nonCouponManualSettlement.vue";
import ExternalFeeConfigPop from './externalFeeConfigPop.vue'
import {goExportCenter} from "../../../../../utils/tool";
const PoiModel = new poi();
export default {
  name: "manageList",
  components: {
    PopSettledCommission,
    PopDistributeGoodsNum,
    PopDarenNum,
    NonCouponCommissionDetail,
    NonCouponCommissionSetting,
    NonCouponAutoSettleSetting,
    NonCouponManualSettlement,
    ExternalFeeConfigPop,
    GroupCommissionPop: GroupSettingPop,
    manageDetailPop,
    ContactInfo
  },
  data() {
    return {
      searchForm: {
        searchContent: '',
        timeArr: null
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      listRequestId: 0,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      exportLoading: false,
      selectedIds: [],
      selectedUserUUIDs: []
    }
  },
  created() {
    this.getList();
  },
  methods:{
    handleSettledCommission(row){
      this.$refs.popSettledCommissionRef.open({
        userUUID: row.userUUID
      })
    },
    handleNonCouponCommissionDetail(row) {
      this.$refs.nonCouponCommissionDetailRef.open(row)
    },
    handleDistributeGoodsNum(row){
      this.$refs.popDistributeGoodsNumRef.open({
        userUUID: row.userUUID
      })
    },
    handleDarenNum(row){
      this.$refs.popDarenNumRef.open({
        userUUID: row.userUUID
      })
    },
    handleRefresh() {
      this.reset()
      this.getList();
    },
    async handleManage(row){
      this.$refs.groupCommissionPopRef.open(row)
    },
    handleBatchNonCouponCommission() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请先选择需要设置的团长。')
        return
      }
      if (this.selectedUserUUIDs.some(userUUID => !userUUID)) {
        this.$message.error('团长UUID不能为空')
        return
      }
      this.$refs.nonCouponCommissionSettingRef.open({
        isBatch: true,
        userUUIDs: [...this.selectedUserUUIDs],
        row: null
      })
    },
    handleNonCouponCommission(row) {
      if (!row.userUUID) {
        this.$message.error('团长UUID不能为空')
        return
      }
      this.$refs.nonCouponCommissionSettingRef.open({
        isBatch: false,
        userUUIDs: [row.userUUID],
        row
      })
    },
    handleNonCouponCommissionSuccess() {
      this.getList()
    },
    handleOpenNonCouponAutoSettleSetting() {
      this.$refs.nonCouponAutoSettleSettingRef.open()
    },
    handleNonCouponAutoSettleSuccess() {
      this.getList()
    },
    handleOpenNonCouponManualSettlement() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请先选择需要结佣的团长。')
        return
      }
      if (
        this.selectedUserUUIDs.length !== this.selectedIds.length ||
        this.selectedUserUUIDs.some(userUUID => typeof userUUID !== 'string' || !userUUID.trim())
      ) {
        this.$message.error('团长UUID不能为空')
        return
      }
      if (new Set(this.selectedUserUUIDs).size !== this.selectedUserUUIDs.length) {
        this.$message.error('团长UUID数据异常，请刷新后重试')
        return
      }
      this.$refs.nonCouponManualSettlementRef.open({
        userUUIDs: [...this.selectedUserUUIDs]
      })
    },
    handleOpenExternalFeeConfig() {
      this.$refs.externalFeeConfigRef.open()
    },
    handleNonCouponManualSettlementSuccess() {
      this.getList()
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
      this.selectedUserUUIDs = selection.map(item => item.userUUID)
    },
    clearTableSelection() {
      this.selectedIds = []
      this.selectedUserUUIDs = []
      this.$refs.multipleTableRef && this.$refs.multipleTableRef.clearSelection()
    },
    getParams(){
      const params = {
        ...this.searchForm
      }
      params.timeStart = this.searchForm.timeArr ? this.searchForm.timeArr[0] : '';
      params.timeEnd = this.searchForm.timeArr ? this.searchForm.timeArr[1] : '';
      delete params.timeArr
      return {
        ...this.openParams,
        ...params
      }
    },
    async getList() {
      const requestId = ++this.listRequestId
      this.loading = true
      try {
        const res = await PoiModel.getAgentSearch({
          ...this.getParams(),
          pageNo: this.params.pageNo,
          pageSize: this.params.pageSize,
        });
        if (requestId !== this.listRequestId) return
        if(res.data.code !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        this.tableList.list = res.data.data.list || [];
        this.tableList.total = res.data.data.total || 0;
        this.tableList.currentPage = res.data.data.pageNo;
        this.tableList.pageSize = res.data.data.pageSize;
      } catch (error) {
        if (requestId !== this.listRequestId) return
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error && error.message
            ? error.message
            : '获取团长列表失败'
        this.$message.error(message)
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false;
        }
      }
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.clearTableSelection()
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
        timeArr: null
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.clearTableSelection()
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val;
      this.getList();
    },
    async onExport(){
      this.exportLoading = true;
      const res = await PoiModel.exportAgentSearch({
        ...this.getParams(),
      }).finally(()=>{
        this.exportLoading = false;
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.exportLoading = false;
      await goExportCenter()
    }
  },
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: right;
}
/deep/ .toolbar-actions .el-form-item__content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.operation-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .el-link {
    white-space: nowrap;
  }
  .el-link + .el-link {
    margin-top: 6px;
  }
}
@media (max-width: 1100px) {
  .toolbar-actions {
    flex-basis: 100%;
    min-width: 0;
  }
  /deep/ .toolbar-actions .el-form-item__content {
    max-width: calc(100vw - 280px);
  }
}
.selected-ids {
  display: inline-block;
  margin-left: 10px;
  max-width: 600px;
  max-height: 60px;
  overflow-y: auto;
  vertical-align: middle;
  color: #606266;
  line-height: 20px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/groupList.vue